import { RiskAssessmentTemplateResourceType } from "@components/shared/risk-assessment-templates/constants";

export const riskAssessmentReportResourceMap: Record<RiskAssessmentTemplateResourceType, string> = {
  [RiskAssessmentTemplateResourceType.DELIVERY]: "deliveries",
  [RiskAssessmentTemplateResourceType.LOCATION]: "locations",
  [RiskAssessmentTemplateResourceType.MATERIAL]: "materials",
  [RiskAssessmentTemplateResourceType.ORGANISATION]: "connections",
  [RiskAssessmentTemplateResourceType.PRODUCT]: "products",
  [RiskAssessmentTemplateResourceType.COUNTRY]: "countries",
};
